<!-- 盘点历史 -->

<template>
    <div class="totalSales" >
        <div class="tableConBox" @click.stop="showType=false">
            <div class="tableTem" @click="searchList=[]">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <!-- <div class="time-range">
                            <span @click="searchByWhichType=='timeRange'?searchByWhichType='dayOrMonth':searchByWhichType='timeRange'">
                                {{searchByWhichType=="timeRange"?'按日/月形式查询':'按时间段查询'}}
                            </span>
                        </div> -->
                        <div class="change-type" v-if="searchByWhichType=='dayOrMonth'">
                            <span @click="nowType='day'">日报</span>
                            <span :class="nowType=='day'?'type-wrap':'type-wrap to-right'" @click="nowType=='day'?nowType='month':nowType='day'" >
                                <i @click.stop=""></i>
                            </span>
                            <span @click="nowType='month'">月报</span>
                        </div>
                        <div class="month-filter" v-if="nowType=='month'&&searchByWhichType=='dayOrMonth'">
                            <el-date-picker
                            v-model="valueForMonth"
                            value-format="yyyy-MM"
                            format="yyyy 年 MM 月"
                            :picker-options="pickerOptions0"
                            type="month"
                            class="dateTime"
                            placeholder="选择月">
                            </el-date-picker>
                        </div>
                        <div class="day-filter" v-if="nowType=='day'&&searchByWhichType=='dayOrMonth'">
                            <el-date-picker
                            v-model="nowDay"
                            type="date"
                            placeholder="选择日期"
                            format="yyyy 年 MM 月 dd 日"
                            value-format="yyyy-MM-dd"
                            class="dateTime"
                            :picker-options="pickerOptionsForDay"
                            >
                            </el-date-picker>
                        </div>
                        <div class="time-range-filter" v-show="searchByWhichType=='timeRange'&&!isUseRangeTime">
                            <el-date-picker
                            v-model="startTime"
                            type="datetime"
                            class="dateTime"
                            default-time="00:00:00"
                            :picker-options="pickerOptionsForTimeRange"
                            placeholder="开始时间">
                            </el-date-picker>
                            <el-date-picker
                            v-model="endTime"
                            type="datetime"
                            class="dateTime"
                            default-time="23:59:59"
                            :picker-options="pickerOptionsForTimeRange"
                            placeholder="结束时间">
                            </el-date-picker>
                        </div>
                        <div class="time-range-filter" v-show="searchByWhichType=='timeRange'&&isUseRangeTime">
                            <el-date-picker
                            v-model="startTime"
                            type="date"
                            class="dateTime"
                            default-time="00:00:00"
                            :picker-options="pickerOptionsForTimeRange"
                            placeholder="开始时间">
                            </el-date-picker>
                            <el-date-picker
                            v-model="endTime"
                            type="date"
                            class="dateTime"
                            default-time="23:59:59"
                            :picker-options="pickerOptionsForTimeRange"
                            placeholder="结束时间">
                            </el-date-picker>
                        </div>
                        <el-checkbox v-if="searchByWhichType=='timeRange'" v-model="isUseRangeTime">每一天的时间段</el-checkbox>
                        <el-time-picker
                            v-if="searchByWhichType=='timeRange'&&isUseRangeTime"
                            is-range
                            v-model="rangeTime"
                            range-separator="至"
                            start-placeholder="开始时间"
                            class="dateTime"
                            end-placeholder="结束时间"
                            placeholder="选择时间范围">
                        </el-time-picker>
                        <div class="types">
                            <el-select v-model="orderSource" placeholder="请选择">
                                <el-option
                                v-for="item in orderSourceOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="types">
                            分类选择：
                            <!-- <el-select v-model="typeId">
                                <el-option
                                  v-for="item in typeList"
                                  :key="item.id"
                                  :label="item.name"
                                  :value="item.id">
                                </el-option>
                            </el-select> -->
                            <!-- <el-cascader
                                v-model="typeId"
                                :options="options"
                                :show-all-levels="false"
                                class="type-style"
                            ></el-cascader> -->
                            <div class="type-sel" @click.stop="showType=!showType">
                                <span class="tit">{{isSelAll?'全部':(selType.length>0?`${selType[0]}...`:'分类选择')}}</span>
                                <div class="type-item" v-if="showType" @click.stop="">
                                    <ul>
                                        <li>
                                            <div>
                                            <label><input type="checkbox" :value="'ALL'" @click.stop="selAll" v-model="isSelAll" />全部</label>
                                            </div>
                                            <div v-for="(item,index) in  options" :key="index">
                                                <label><input type="checkbox" v-model="selType" :value="item.value" />{{item.label}}</label>
                                            </div> 
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="types">
                            商品选择：
                            <el-input
                                placeholder="请输入商品名称"
                                prefix-icon="el-icon-search"
                                v-model="searchKeywords"
                                @focus="searchKeywords='';goodId=''">
                            </el-input>
                            <ul class="searchInner" :style="{display:(searchList[0]?'block':'none')}" @click.stop="">
                                <li v-for="item in searchList" v-text="item.name" @click="selGood(item)"></li>
                            </ul>
                        </div> -->
                        <span class="quick-filter">
                            <span :class="nowSelFilter=='today'?'active':''" @click.stop="filter('today')">今日</span>
                            <span :class="nowSelFilter=='lastDay'?'active':''" @click.stop="filter('lastDay')">昨日</span>
                            <span :class="nowSelFilter=='week'?'active':''" @click.stop="filter('week')">本周</span>
                            <span :class="nowSelFilter=='lastWeek'?'active':''" @click.stop="filter('lastWeek')">上周</span>
                            <span :class="nowSelFilter=='month'?'active':''" @click.stop="filter('month')">本月</span>
                            <span :class="nowSelFilter=='lastMonth'?'active':''" @click.stop="filter('lastMonth')">上月</span>
                        </span>
                        <span class="types typesSearch">
                            <span type="button" @click="searchConfirm">查询</span>
                        </span>
                        <div style="color:#f54747;font-size:14px;lineHeight:18px;">不包含会员充值和退单数据！</div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:10%">序号</th>
                                <th style="width:30%">商品名称</th>
                                <th style="width:10%">数量</th>
                                <th style="width:10%">售价</th>
                                <th style="width:15%">一级分类</th>
                                <th style="width:15%">二级分类</th>
                                <th style="width:10%">总计</th>
                            </tr>
                        </table>
                        <div class="scrollBox"  v-if="nowType=='day'&&searchByWhichType=='dayOrMonth'">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:workData.length>10}" v-if="workData.length>0">
                                    <tr v-for="(item,ind) in workData">
                                        <td style="width:10%" >
                                            <span v-text="ind+1" v-if="item.name"></span>
                                            <span v-if="!item.name"></span>
                                        </td>
                                        <td style="width:30%;" v-text="item.name"></td>
                                        <td style="width:10%" v-text="item.qty"></td>
                                        <td style="width:10%" v-text="item.salesPrice"></td>
                                        <td style="width:15%" v-text="item.parentTypeName"></td>
                                        <td style="width:15%" v-text="item.typeName"></td>
                                        <td style="width:10%">{{item.amount | toFixedNum}}</td>
                                    </tr>
                                </table>
                                <div class="no-data" v-else>
                                    暂无记录，请点击查询或者重新选择查询条件。
                                </div>
                            </div>
                        </div>
                        <div class="tableBox scrollBox tableBox-for-month" v-if="nowType=='month'&&searchByWhichType=='dayOrMonth'">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:workDataForMonth.length>10}" v-if="workDataForMonth.length>0">
                                    <tr v-for="(item,ind) in workDataForMonth">
                                        <td style="width:10%" >
                                            <span v-text="ind+1" v-if="item.name"></span>
                                            <span v-if="!item.name"></span>
                                        </td>
                                        <td style="width:30%;" v-text="item.name"></td>
                                        <td style="width:10%" v-text="item.qty"></td>
                                        <td style="width:10%" v-text="item.salesPrice"></td>
                                        <td style="width:15%" v-text="item.parentTypeName"></td>
                                        <td style="width:15%" v-text="item.typeName"></td>
                                        <td style="width:10%">{{item.amount | toFixedNum}}</td>
                                    </tr>
                                </table>
                                <div class="no-data" v-else>
                                    暂无记录，请点击查询或者重新选择查询条件。
                                </div>
                            </div>
                        </div>
                        <div class="tableBox scrollBox tableBox-for-month" v-if="searchByWhichType=='timeRange'">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:workDataForTimeRange.length>10}" v-if="workDataForTimeRange.length>0">
                                    <tr v-for="(item,ind) in workDataForTimeRange">
                                        <td style="width:10%" >
                                            <span v-text="ind+1" v-if="item.name"></span>
                                            <span v-if="!item.name"></span>
                                        </td>
                                        <td style="width:30%;" v-text="item.name"></td>
                                        <td style="width:10%" v-text="item.qty"></td>
                                        <td style="width:10%" v-text="item.salesPrice"></td>
                                        <td style="width:15%" v-text="item.parentTypeName"></td>
                                        <td style="width:15%" v-text="item.typeName"></td>
                                        <td style="width:10%">{{item.amount | toFixedNum}}</td>
                                    </tr>
                                </table>
                                <div class="no-data" v-else>
                                    暂无记录，请点击查询或者重新选择查询条件。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 分页器 -->
                <div class="pager flex flex-align-center" v-if="nowType=='day'&&searchByWhichType=='dayOrMonth'">
                    <div class="pagerCon clearfix">
                        <span class="right excel" @click="excel">导出Excel</span>
                        <!--<span class="left item">总收入:<span class="num color3" v-text="((salesData.cashAmount+salesData.wechatAmount+salesData.wechatCashAmount+salesData.alipayCashAmount+salesData.alipayAmount+salesData.memberAmount+salesData.couponAmount)/100).toFixed(2)"></span></span>-->
                        <span class="left item">数量:<span class="num color3" v-text="allQty"></span></span>
                        <span class="left item">总收入:<span class="num color5">{{allAmount | toFixedNum}}</span>
                            <span v-if="channelInfo" class="channel-info">
                                <span>微信：{{channelInfo.wechatAmount}}</span>
                                <span>、支付宝：{{channelInfo.aliAmount}}</span>
                                <span>、会员支付：{{channelInfo.memberAmount}}</span>
                                <span>、银联支付：{{channelInfo.unionpayAmount}}</span>
                                <span>、现金支付：{{channelInfo.cashAmount}}</span>
                            </span>
                        </span>
                        <!--<span class="left item">现金:<span class="num color5" v-text="salesData.cashAmount/100"></span></span>
                        <span class="left item">微信:<span class="num color4" v-text="salesData.wechatAmount/100"></span></span>
                        <span class="left item">支付宝:<span class="num color1"  v-text="salesData.alipayAmount/100"></span></span>
                        <span class="left item">线下微信:<span class="num color1"  v-text="salesData.wechatCashAmount/100"></span></span>
                        <span class="left item">线下支付宝:<span class="num color1"  v-text="salesData.alipayCashAmount/100"></span></span>
                        <span class="left item">会员:<span class="num color3" v-text="salesData.memberAmount/100"></span></span>
                        <span class="left item">优惠券:<span class="num color2" v-text="salesData.couponAmount/100"></span></span>-->
                    </div>
                </div>
                <div class="pager flex flex-align-center" v-if="nowType=='month'&&searchByWhichType=='dayOrMonth'">
                    <div class="pagerCon clearfix">
                        <span class="right excel" @click="excel">导出Excel</span>
                        <!--<span class="left item">总收入:<span class="num color3" v-text="((salesData.cashAmount+salesData.wechatAmount+salesData.wechatCashAmount+salesData.alipayCashAmount+salesData.alipayAmount+salesData.memberAmount+salesData.couponAmount)/100).toFixed(2)"></span></span>-->
                        <span class="left item">数量:<span class="num color3" v-text="allQtyForMonth"></span></span>
                        <span class="left item">总收入:<span class="num color5">{{allAmountForMonth | toFixedNum}}</span>
                            <span v-if="channelInfo" class="channel-info">
                                <span>微信：{{channelInfo.wechatAmount}}</span>
                                <span>、支付宝：{{channelInfo.aliAmount}}</span>
                                <span>、会员支付：{{channelInfo.memberAmount}}</span>
                                <span>、银联支付：{{channelInfo.unionpayAmount}}</span>
                                <span>、现金支付：{{channelInfo.cashAmount}}</span>
                            </span>
                        </span>
                        <!--<span class="left item">现金:<span class="num color5" v-text="salesData.cashAmount/100"></span></span>
                        <span class="left item">微信:<span class="num color4" v-text="salesData.wechatAmount/100"></span></span>
                        <span class="left item">支付宝:<span class="num color1"  v-text="salesData.alipayAmount/100"></span></span>
                        <span class="left item">线下微信:<span class="num color1"  v-text="salesData.wechatCashAmount/100"></span></span>
                        <span class="left item">线下支付宝:<span class="num color1"  v-text="salesData.alipayCashAmount/100"></span></span>
                        <span class="left item">会员:<span class="num color3" v-text="salesData.memberAmount/100"></span></span>
                        <span class="left item">优惠券:<span class="num color2" v-text="salesData.couponAmount/100"></span></span>-->
                    </div>
                </div>
                <div class="pager flex flex-align-center" v-if="searchByWhichType=='timeRange'">
                    <div class="pagerCon clearfix">
                        <span class="right excel" @click="excel">导出Excel</span>
                        <!--<span class="left item">总收入:<span class="num color3" v-text="((salesData.cashAmount+salesData.wechatAmount+salesData.wechatCashAmount+salesData.alipayCashAmount+salesData.alipayAmount+salesData.memberAmount+salesData.couponAmount)/100).toFixed(2)"></span></span>-->
                        <span class="left item">数量:<span class="num color3" v-text="allQtyForTimeRange"></span></span>
                        <span class="left item">
                            <!-- 总收入:<span class="num color5">{{allAmountForTimeRange | toFixedNum}}</span> -->
                            <!--  -->
                            <span>总收入:  
                                <span class="num color5">{{allAmountForTimeRange | toFixedNum}}</span>
                                <span class="num color5" style="font-size:16px;padding-right:10px;" v-if="channelInfo && channelInfo.memberAmount"><span style="color:#000">总实收：</span><span style="font-size:22px">{{(allAmountForTimeRange - channelInfo.memberAmount).toFixed(2)}}</span></span>
                            </span>
                            <!--  -->
                            <span v-if="channelInfo" class="channel-info">
                                <span>微信：{{channelInfo.wechatAmount}}</span>
                                <span>、支付宝：{{channelInfo.aliAmount}}</span>
                                <span>、会员支付：{{channelInfo.memberAmount}}</span>
                                <span>、银联支付：{{channelInfo.unionpayAmount}}</span>
                                <span>、现金支付：{{channelInfo.cashAmount}}</span>
                            </span>
                        </span>
                        <!--<span class="left item">现金:<span class="num color5" v-text="salesData.cashAmount/100"></span></span>
                        <span class="left item">微信:<span class="num color4" v-text="salesData.wechatAmount/100"></span></span>
                        <span class="left item">支付宝:<span class="num color1"  v-text="salesData.alipayAmount/100"></span></span>
                        <span class="left item">线下微信:<span class="num color1"  v-text="salesData.wechatCashAmount/100"></span></span>
                        <span class="left item">线下支付宝:<span class="num color1"  v-text="salesData.alipayCashAmount/100"></span></span>
                        <span class="left item">会员:<span class="num color3" v-text="salesData.memberAmount/100"></span></span>
                        <span class="left item">优惠券:<span class="num color2" v-text="salesData.couponAmount/100"></span></span>-->
                    </div>
                </div>
            </div>
        </div>
        <table id="scrollBox" style="display:none"> 
        </table>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        props:['curStoreId', 'pageSize'],
        data () {
            return {
                channelInfo:null,
                orderSource:"ALL",
                orderSourceOptions:[
                    {
                        label:"全部",
                        value:"ALL"
                    },
                    {
                        label:"收银端",
                        value:"POS"
                    },
                    {
                        label:"店员宝",
                        value:"EMPLOYEE"
                    },
                    {
                        label:"微信点单",
                        value:"WEIXIN"
                    },
                    {
                        label:"客户端点单",
                        value:"WEB"
                    }
                ],
                nowSelFilter:"today",
                isSelAll:true,
                selType:[],
                showType:false,
                rangeTime:[],//时间段的值
                isUseRangeTime:false,//是否使用时间段
                workDataForTimeRange:[],
                allAmountForTimeRange:0,
                allQtyForTimeRange:0,
                startTime:'',//开始时间
                endTime:'',//结束时间
                nowTimeRange:"",
                searchByWhichType:"timeRange",//按照时间段或者是日月报的形式查询，dayOrMonth,timeRange
                valueForMonth:'',//月份信息
                workDataForMonth:[],//月报数据
                allAmountForMonth:0,//月报总金额
                allAmount:0,//总金额
                allQtyForMonth:0,//月报总数量
                allQty:0,//总数量
                nowDay:'',//当前日期
                nowType:"day",//当前查询方式，如日报，月报
                workData:[],
                workCalculateData:{
                	amount:0,
                	quantity:0
                },
                getBtn: true, // 控制翻页请求
                pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                pickerOptionsForTimeRange:{
                   disabledDate(time) {
                    
                    //    let date = (new Date(time));
                    // //    let dateStr = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();
                    // //    let newDate = new Date(dateStr).getTime();
                    // //    let newDateForNextMonth = new Date(date.getFullYear(),(date.getMonth()+1),0).getTime();
                    // //    return time.getTime() < newDate || time.getTime() > newDateForNextMonth;
                    //     let curDate = (new Date()).getTime();
                    //     let three = 30 * 24 * 3600 * 1000;
                    //     let threeDays = curDate - three;
                    //     return time.getTime() > Date.now() || time.getTime() < threeDays;
                    } 
                },
                pickerOptionsForDay: {
                //时间禁用,今天以后的时间禁用。
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                salesData:{
                    turnInAmount: 0,
                    cashAmount: 0,
                    wechatAmount: 0,
                    alipayAmount: 0,
                    memberAmount: 0,
                    couponAmount: 0,
                    wechatCashAmount: 0,
                    alipayCashAmount: 0
                },//销售数据

                typeList: [{
                    name: '全部',
                    id: ''
                }], // 分类
                
                timeFrom:'',//开始时间
                timeTo:'',//截止时间
                typeId: ['ALL'], // 分类id
                goodId: '', // 商品id
                searchKeywords: '',// 搜索关键字
                searchList: [], // 搜索结果数组
                goodSearchBtn: true, // 控制搜索框
                canSearch: true, //
                options:[] 
            }
        },
        watch:{
            selType(val){
                console.log(val)
                if(val.length == this.options.length){
                    this.isSelAll = true;
                }else{
                    this.isSelAll = false;
                }
            },
            isUseRangeTime(val){
                this.startTime='';
                this.endTime='';
            },
            searchKeywords : function(val){
                if ( this.canSearch ) {
                    this.goodSearch();
                } else {
                    this.canSearch = true;
                }
            },
            endTime(val){
                console.log(val)
                let days = 1000*60*60*24*45;
                if(this.startTime!==""){
                    if(new Date(val) - new Date(this.startTime) > days){
                        this.$message({
                            message: '查询时间段最多45天',
                            customClass: 'error'
                        })
                    }
                }else{
                    this.$message({
                        message: '请选择起始时间',
                        customClass: 'error'
                    })
                }
                
                    //    let dateStrForNextMonth = date.getFullYear()+'-'+(date.getMonth()+2)+'-'+'00';
                    //    console.log(dateStrForNextMonth)
                    //    let newDateForNextMonth = new Date(2018,11,0).getTime();
                    //    let date = new Date(newDateForNextMonth);
                    //    console.log(date.getDate())
            }
        },
        methods: {
            filter(type){
                let timeRangeArr = [];
                this.nowSelFilter = type;
                switch (type) {
                    case "today":
                        // this.yearMonth = new Date().Format("yyyy-MM");
                        this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
                        // let year = new Date().Format("yyyy");
                        // let month = new Date().Format("MM");
                        this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastDay":
                        this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
                        this.startTime = `${new Date(new Date(this.startTime).getTime() - 1000*60*60*24).Format("yyyy/MM/dd")} 00:00:00`;
                        this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
                        this.endTime = `${new Date(new Date(this.endTime).getTime() - 1000*60*60*24).Format("yyyy/MM/dd")} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "week":
                        timeRangeArr = this.$dateRange.getThisWeek();
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastWeek":
                        timeRangeArr = this.$dateRange.getLastWeek();
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "month":
                        timeRangeArr = this.$dateRange.getThisMonth();
                        console.log(timeRangeArr)
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    case "lastMonth":
                        timeRangeArr = this.$dateRange.getLastMonth();
                        console.log(timeRangeArr)
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.searchConfirm();
                        break;
                    default:
                        break;
                }
            },
            selAll(){
                this.isSelAll = !this.isSelAll;
                if(this.isSelAll){
                    let selType = [];
                    for (let i = 0; i < this.options.length; i++) {
                        selType.push(this.options[i].value);
                    }
                    this.selType = selType;
                }else{
                    this.selType = [];
                }
                
            },
            selGood: function ( item ) {
                this.canSearch = false;
                this.searchKeywords = item.name;
                this.goodId = item.id;
                this.searchList = [];
            },
            // 商品检索
            goodSearch: function () {
                let val = this.searchKeywords;
                if ( !val ) {
                    this.searchList = [];
                    return;
                }
                if ( !this.goodSearchBtn ) {
                    return;
                }
                this.goodSearchBtn = false;
                this.$http.get('products/search?storeId='+this.curStoreId+'&q='+encodeURI(val)).then((res)=>{
                    this.searchList = res.data;
                    for (var i = 0, len = this.searchList.length; i < len; i++) {
                        if ( this.searchKeywords == this.searchList[i].name ) {
                            this.goodId = this.searchList[i].id;
                            break;
                        } else {
                            this.goodId = '';
                        }
                    }
                    this.goodSearchBtn = true;
                }).catch(()=>{
                    this.goodSearchBtn = true;
                })
            },
            // 搜索
            searchConfirm: function () {
                let date = new Date(this.nowDay).Format("yyyy-MM-dd");
                let dateForMonth = new Date(this.valueForMonth).Format("yyyy-MM");
                
                //分类形式
                // let type = this.typeId[0];
                if(this.selType.length==0){
                    this.$message({
                        message: '请选择分类',
                        customClass: 'error'
                    });
                    return;
                }
                let type = this.selType.join(",");
                console.log(type);
                // return;
                if(this.searchByWhichType === "dayOrMonth"){
                    if(this.nowType=='month'){
                    if(dateForMonth){
                        this.getSalesCount(dateForMonth,type,"MONTH");
                        // this.getWordData();
                        // this.getSales();
                    } else {
                        this.$message({
                            message: '请选择查询时间',
                            customClass: 'error'
                        })
                    }
                    }else{
                        if(date){
                            this.getSalesCount(date,type,"DAY");
                            // this.getWordData();
                            // this.getSales();
                        } else {
                            this.$message({
                                message: '请选择查询时间',
                                customClass: 'error'
                            })
                        }
                    }
                }else{
                    if(this.startTime!=='' && this.endTime!==''){
                        if(new Date(this.startTime)>new Date(this.endTime)){
                            this.$message({
                                message: '结束时间不能比开始时间小',
                                customClass: 'error'
                            })
                            return;
                        }
                        if(this.isUseRangeTime){
                            if(!this.rangeTime || this.rangeTime.length<2){
                                this.$message({
                                    message: '请选择每一天的时间段',
                                    customClass: 'error'
                                })
                                return;
                            }
                            // let fromSecond = new Date(this.rangeTime[0]).getTime();
                            // let toSecond = new Date(this.rangeTime[1]).getTime();
                            // if(fromSecond>toSecond){
                            //     this.$message({
                            //         message: '起始时间应该小于截止时间',
                            //         customClass: 'error'
                            //     })
                            //     return;
                            // }
                        }
                        // if((new Date(this.startTime).getMonth()+1)!==(new Date(this.endTime).getMonth()+1)){
                        //     this.$message({
                        //         message: '只能选择所选月份内的时间段，不可跨月查询。',
                        //         customClass: 'error'
                        //     })
                        //     return;
                        // }
                        let days = 1000*60*60*24*45;
                        if(new Date(this.endTime) - new Date(this.startTime) > days){
                            this.$message({
                                message: '查询时间段最多45天',
                                customClass: 'error'
                            });
                            return;
                        }
                        //起止时间
                        let startTime = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                        let endTime = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                        if(this.isUseRangeTime){
                            startTime = new Date(this.startTime).Format("yyyy-MM-dd")+" 00:00:00";
                            endTime = new Date(this.endTime).Format("yyyy-MM-dd")+" 23:59:59";
                        }
                        this.getSalesCount({startTime,endTime},type,"timeRange");
                    }else{
                        this.$message({
                            message: '请选择查询时间段',
                            customClass: 'error'
                        })
                        return;
                    }
                }
                
                
                // if(this.timeTo&&this.timeFrom){
                //     if(new Date(this.timeFrom)>new Date(this.timeTo)){
                //         this.$message({
                //             message: '结束时间不能比开始时间小',
                //             customClass: 'error'
                //         })
                //         return;
                //     }
                //     this.getWordData();
                //     this.getSales();
                // } else {
                //     this.$message({
                //         message: '请选择查询时间段',
                //         customClass: 'error'
                //     })
                // }
            },
            getSalesCount(date,type,source){
                let params;
                if(this.searchByWhichType === "dayOrMonth"){
                    if(source=="DAY"){
                        params = {
                            storeId:this.curStoreId,
                            time:date,
                            type,
                            source
                        }
                        // 
                        let timeStr = new Date(date).getTime() + "-"+type+"-" + new Date(date).getTime();
                        let nowTime = new Date().getTime();
                        if(!(this.$canClickSelect("totalSalesDay",timeStr,nowTime))){
                            this.$message({
                                message: '5秒内禁止重复查询相同数据',
                                customClass: 'error'
                            });
                            return;
                        }
                        // 
                    }else{
                        let dateObj = new Date(date);
                        let year = dateObj.getFullYear();
                        let month = dateObj.getMonth() + 1;
                        params = {
                            storeId:this.curStoreId,
                            type,
                            year,
                            month,
                            source
                        }
                        // 
                        let timeStr = new Date(date).getTime() + "-"+type+"-" + new Date(date).getTime();
                        let nowTime = new Date().getTime();
                        if(!(this.$canClickSelect("totalSalesMonth",timeStr,nowTime))){
                            this.$message({
                                message: '5秒内禁止重复查询相同数据',
                                customClass: 'error'
                            });
                            return;
                        }
                        //
                    }
                }else{
                    let dateObj = date;
                    let startTime = date.startTime;
                    let endTime = date.endTime;
                    let judge = this.isUseRangeTime;
                    let fromSecond = 0;
                    let toSecond = 0;
                    let nowDate = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
                    if(this.isUseRangeTime){
                        fromSecond = parseInt((this.rangeTime[0] - nowDate) / 1000);
                        toSecond = parseInt((this.rangeTime[1] - nowDate) / 1000);
                    }
                    params = {
                        storeId:this.curStoreId,
                        type,
                        from:startTime,
                        to:endTime,
                        source,
                        judge,
                        fromSecond,
                        toSecond
                    }
                    // 
                    let timeStr = new Date(startTime).getTime() + "-"+type+"-" + new Date(endTime).getTime();
                    let nowTime = new Date().getTime();
                    if(!(this.$canClickSelect("totalSalesTimeRange",timeStr,nowTime))){
                        this.$message({
                            message: '5秒内禁止重复查询相同数据',
                            customClass: 'error'
                        });
                        return;
                    }
                    //
                }
                params["orderSource"] = this.orderSource;
                if(this.isSelAll){
                    params["typeAll"] = "ALL";
                }else{
                    params["typeAll"] = "ELSE";
                }
                this.$http({
                    url:"get-salesCount",
                    method:"GET",
                    params
                }).then(res=>{
                    console.log(res);
                    this.channelInfo = res.data.channel;
                    if(this.searchByWhichType === "dayOrMonth"){
                        if(source == "DAY"){
                        this.workData = res.data.data;
                        this.allAmount = res.data.allAmount;
                        this.allQty = res.data.allQty;
                        }else{
                            this.workDataForMonth = res.data.data;
                            this.allAmountForMonth = res.data.allAmount;
                            this.allQtyForMonth = res.data.allQty; 
                        }
                    }else{
                            this.workDataForTimeRange = res.data.data;
                            this.allAmountForTimeRange = res.data.allAmount;
                            this.allQtyForTimeRange = res.data.allQty; 
                    }
                });
            },
            //搜索条件
            conditionFn(){
                // console.log(this.typeId);
                let URL = '';
                this.timeFrom    ? URL += ('?from='+new Date(this.timeFrom).Format('yyyy-MM-dd hh:mm:ss')):'';
                this.timeTo      ? URL += ('&to='+new Date(this.timeTo).Format('yyyy-MM-dd hh:mm:ss')):'';
                URL += '&productTypeId='+this.typeId[this.typeId.length-1]+'&productId='+this.goodId;
                return URL;
            },
            //获取消费记录列表
            getWordData(){
                if ( !this.getBtn ) {
                    return;
                }
                this.getBtn = false;
                this.workCalculateData.amount = 0;
                this.workCalculateData.quantity = 0;
                let url = this.conditionFn();
                this.$http.get(this.curStoreId+'/product-sales'+url).then((res)=>{
                    this.workData = res.data;
                    if( this.workData.length < this.pageSize ){
                        for(let i = 0, len = this.pageSize - this.workData.length; i < len; i++){
                            this.workData.push({})
                        }
                    }
                    for(let i = 0,len = this.workData.length;i<len;i++){
                        if(this.workData[i].productId){
                            this.workData[i].single = (this.workData[i].amount/this.workData[i].quantity).toFixed(2);
                            this.workCalculateData.amount+=this.workData[i].amount;
                            this.workCalculateData.quantity+=this.workData[i].quantity;
                        }
                    }
                    this.getBtn = true;
                    this.workCalculateData.amount = this.workCalculateData.toFixed(2);
                	this.workCalculateData.quantity = this.workCalculateData.quantity.toFixed(2);
                }).catch(()=>{
                    this.getBtn = true;
                })
            },
            getSales(){
                let url = this.conditionFn();
                this.$http.get(this.curStoreId+'/sales-total'+url).then((res)=>{
                    this.salesData = res.data;
                })
            },
            //导出按钮
            excel(){
                let data,amount,qty;
                console.log(this.nowType)
                if(this.searchByWhichType === "dayOrMonth"){
                    if(this.nowType == "day"){
                        console.log("执行了")
                        if ( !this.workData[0].name ) {
                            this.$message({
                                message: '无数据可导出',
                                customClass: 'error'
                            })
                            return;
                        }
                        data = this.workData;
                        amount = this.allAmount;
                        qty = this.allQty;
                    }else{
                        if ( !this.workDataForMonth[0].name ) {
                            this.$message({
                                message: '无数据可导出',
                                customClass: 'error'
                            })
                            return;
                        }
                        data = this.workDataForMonth;
                        amount = this.allAmountForMonth;
                        qty = this.allQtyForMonth;
                    }
                }else{
                    if ( !this.workDataForTimeRange[0].name ) {
                            this.$message({
                                message: '无数据可导出',
                                customClass: 'error'
                            })
                            return;
                        }
                        data = this.workDataForTimeRange;
                        amount = this.allAmountForTimeRange;
                        qty = this.allQtyForTimeRange;
                }
                
                
                let num =0,price=0;
                let html = '<tr>'+  
                                '<td style="font-size:18px">商品名称</td>'+
                                '<td style="font-size:18px">售价</td>'+
                                '<td style="font-size:18px">数量</td>'+ 
                                '<td style="font-size:18px">一级分类</td>'+ 
                                '<td style="font-size:18px">二级名字</td>'+ 
                                '<td style="font-size:18px">总计</td>'+
                            '</tr>'
                        for(var i=0;i<data.length;i++){
                            if ( !data[i].name ) {
                                continue;
                            }

                            num+=data[i].qty;
                            price+=data[i].amount;
                            html  +='<tr>'+
                                        '<td>'+data[i].name+'</td>'+
                                        '<td>'+data[i].salesPrice+'</td>'+ 
                                        '<td>'+data[i].qty+'</td>'+ 
                                        '<td>'+data[i].parentTypeName+'</td>'+ 
                                        '<td>'+data[i].typeName+'</td>'+ 
                                        '<td>'+data[i].amount+'</td>'+ 
                                    '</tr>'
                        }
                    html += 
                            '<tr>'+
                                '<td style="font-size:16px">总金额</td>'+
                                '<td></td>'+ 
                                '<td></td>'+ 
                                '<td>'+amount+'</td>'+ 
                            '</tr>'
                    if(this.channelInfo && this.channelInfo.memberAmount){
                        html+='<tr>'+
                                '<td style="font-size:16px">总实收</td>'+
                                '<td></td>'+ 
                                '<td></td>'+ 
                                '<td>'+Number(Number(amount) - Number(this.channelInfo.memberAmount)).toFixed(2)+'</td>'+ 
                            '</tr>'
                    }
                            html+='<tr>'+
                                '<td style="font-size:16px">总数量</td>'+
                                '<td></td>'+ 
                                '<td></td>'+ 
                                '<td>'+qty+'</td>'+ 
                            '</tr>'
                document.getElementById('scrollBox').innerHTML = html;
                window.method5(scrollBox);
            }
        },
        created: function () {
            for (var i = 0; i < this.pageSize; i++) {
                // this.workData.push({});
            }

            //获取商品分类
            this.$http.get('/product-types-all?storeId='+this.curStoreId+'&parentId='+'').then((res)=>{
                this.typeList = this.typeList.concat(res.data);
               
                // this.options.push({label: '全部',value: 'ALL'});
                for (var i = 0; i < res.data.length; i++) {
                    let obj={
                        value:res.data[i].name,
                        label:res.data[i].name
                    }
                    // if(res.data[i].productTypeVos.length){
                    //     let son = res.data[i].productTypeVos;
                    //     let arr = [
                    //         {value:res.data[i].id,label:res.data[i].name}
                    //     ];
                    //     for (var j = 0; j < son.length; j++) {
                    //          let sonobj={
                    //             value:son[j].id,
                    //             label:"- "+son[j].name
                    //         }
                    //         arr.push(sonobj)
                    //     }
                    //     obj.children = arr;
                    // }
                    this.selType.push(res.data[i].name);
                    this.options.push(obj);
                }
            })
        },
        mounted: function () {
            this.nowDay = new Date();
            this.valueForMonth = new Date();
            // let date = new Date().Format("yyyy-MM-dd");
            // let dateForMonth = new Date().Format("yyyy-MM");
            // this.getSalesCount(date,"ALL");
            console.log(this.workData.length)
            this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
            let year = new Date().Format("yyyy");
            let month = new Date().Format("MM");
            this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
        }
    }
</script>
<style lang="scss">
    @import '../../../../../static/css/common.scss';
    @import '../../../tableTemplate/tableTem.scss';
    @import "totalSales.scss";
</style>



// WEBPACK FOOTER //
// totalSales.vue?05affbe0